"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAddressFromNodeId = exports.generateMnemonicFromAddress = void 0;

var bip39_1 = require("bip39");
/**
 * @param address - valid eth address with leading 0x
 */


var generateMnemonicFromAddress = function generateMnemonicFromAddress(address) {
  return bip39_1.entropyToMnemonic(address.slice(2), bip39_1.wordlists.english).split(' ').slice(0, 3).map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
};

exports.generateMnemonicFromAddress = generateMnemonicFromAddress;
/**
 * @param id - node id
 */

var parseAddressFromNodeId = function parseAddressFromNodeId(id) {
  var hashPos = id.indexOf('#');

  if (hashPos < 0) {
    return id;
  }

  return id.slice(0, hashPos);
};

exports.parseAddressFromNodeId = parseAddressFromNodeId;